export default __webpack_public_path__ + "static/media/Rustic Merry Christmas wreath.d52357aa.jpg";